import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useTranslations } from '../../../../features/providers/translations-provider';
import Button from '../../../common/button';
import Div from '../../../common/div';
import Typography from '../../../common/typography';
const ReviewConfirm = ({ handleClose, isActive }) => {
    const theme = useTheme();
    const { t } = useTranslations();
    if (!isActive)
        return _jsx(_Fragment, {});
    return (_jsxs(Div, { flex: "column", align: "center", gap: 24, children: [_jsxs(Div, { flex: "column", gap: 8, align: "center", children: [_jsx(Typography.Title, { level: 2, elementTheme: "h3", textAlign: "center", children: t('reviews|newReviewThankYouScreenHeader') }), _jsx(Typography, { textAlign: "center", elementTheme: "body1", children: t('reviews|newReviewThankYouScreenDescription') })] }), _jsx(Button, { defaultStyle: theme.colors.yellow_1, onClick: handleClose, children: t('reviews|newReviewThankYouScreenClose') })] }));
};
export default ReviewConfirm;
